export default "__VITE_ASSET__9654d34d__"